import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = null;

export const slice = createSlice({
  name: "gannWheel",
  initialState,
  reducers: {
    updateByName: (state, action) => {
      if (
        action.payload.category === "overlaySettings" &&
        action.payload.name === "barAngle"
      ) {
        // Find center using difference of 15 number
        const x = action.payload.value;
        const extra = x % 15;
        state[action.payload.category][action.payload.name] = x - extra + 7.5;
      } else {
        state[action.payload.category][action.payload.name] =
          action.payload.value;
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(Act.getGannWheel.fulfilled, (state, { payload }) => ({
      ...state,
      ...payload,
    }));
  },
});

export const actions = slice.actions;
export default slice.reducer;
